import brand from "../../brand.config.json";

export const BRAND = brand;

export const COPY = {
  play: "Quick Play",
  replay: "Clog again",
  pause: "Pause game",
  resume: "Resume game",
  settings: "Settings",
  tutorial: "Slide to move. Your jetpack fires automatically!",
  tutorialHint: "Move while pellets fire by themselves",
  bossIncoming: "LID SHIELD INCOMING!",
  waves: {
    one: "Wave 1 · Fresh Fixtures",
    two: "Wave 2 · Swirly Skies",
    three: "Wave 3 · Throne Zone",
    finale: "Finale · Boss Approaching",
    boss: "Boss · Lid Shield",
  },
  boss: {
    approaching: "FINAL FLUSH IN",
    closed: "SHIELD UP — KEEP MOVING",
    open: "SHIELD DOWN — FIRE!",
  },
  announcements: {
    waveOne: "Wave one. Fresh fixtures!",
    bossApproaching: "Final boss arriving in four seconds! Keep moving!",
    bossOpen: "Lid Shield is open!",
    bossBlocking: "Lid Shield is blocking!",
    shieldReady: "Toilet Paper Shield ready! It activates automatically.",
    tripleReady: "Triple Scoop ready! Press Space or tap the Scoop button.",
    recovery: "Recovery swirl caught that one!",
    shieldSaved: "Shield saved your cheeks!",
    bonusLife: "Bonus toilet-paper heart earned!",
    toiletCollision: "Toilet collision! One heart flushed!",
    bubbleUnlocked: "Bubble Blaster unlocked and auto-equipped at 10 clogs!",
    plungerUnlocked:
      "Golden Plunger Cannon unlocked and auto-equipped at 25 clogs!",
    plungerUnlockedHeart:
      "Golden Plunger Cannon unlocked and auto-equipped at 25 clogs! Bonus heart earned!",
    backwardFlush: "Backward Flush! The cosmos is unclogged!",
    tripleActivated: "Triple Scoop activated!",
    tripleEnding: "Triple Scoop is almost finished!",
    tabPaused: "Game paused while the tab is away.",
  },
  powerUps: {
    shield: "Toilet Paper Shield",
    tripleReady: "Triple Scoop ready",
    tripleActive: "Triple Scoop",
    tripleEnding: "Triple Scoop ending!",
    shieldGuide: "Shield ready · activates automatically",
    tripleGuide: "Triple Scoop ready · press Space or tap Scoop",
    tripleActiveGuide: "Triple Scoop active · three-way fire",
  },
  weapons: {
    poop: "Poop Popper",
    bubble: "Bubble Blaster",
    plunger: "Golden Plunger Cannon",
  },
  defeatTitle: "A valiant flush!",
  victoryTitle: "Cosmos unclogged!",
  titles: {
    flawless: "Flawless Flush Royalty",
    champion: "Certified Clog Champion",
    personalBest: "Personal-Best Potty Pilot",
    tenToilet: "Ten-Toilet Legend",
    cadet: "Brave Little Butt Cadet",
  },
  ui: {
    common: {
      settings: "Settings",
      score: "Score",
      combo: "Combo",
      lives: "Lives",
      done: "Done",
      touchAvailable: "Touch remains available.",
    },
    identity: {
      workingTitle: "Working title",
      mission: "Mission",
      missionText: "Fill, wobble, clog!",
      keyboard: "Keyboard",
      keyboardOr: "or",
      keyboardMove: "to glide",
      autoFire: "Pellets fire automatically",
    },
    menu: {
      kicker: "A tiny butt. A giant mission.",
      title: "Clog the cosmos!",
      description:
        "Glide, auto-fire, and fill every mischievous throne before it reaches the Flush Zone.",
      loading: "Polishing the porcelain…",
      ready: "Jetpack fueled. Toilets nervous.",
    },
    hud: {
      initialWave: "Wave 1",
      initialClogs: "0 clogged · 0×",
      autoFireReady: "Auto-fire ready",
      clogged: "clogged",
      noPowerUp: "No power-up",
      gameStatus: "Game status",
      weapon: "Blaster",
    },
    pause: {
      kicker: "Intermission",
      title: "Cheeks on pause",
      defaultReason: "Nothing moves while paused.",
      manualReason:
        "Take your time—nothing moves and no lives are lost while paused.",
      focusReason:
        "The game paused when this tab lost focus. Nothing moved and no lives were lost.",
      settingsReason: "Your run is safely paused while you make it comfy.",
      resume: "Resume",
      restart: "Restart run",
      restartConfirm: "Restart this run from the beginning?",
      focusAnnouncement:
        "Game paused because the tab lost focus. Press Resume when ready.",
      pausedAnnouncement: "Game paused.",
      resumedAnnouncement: "Game resumed.",
    },
    results: {
      runComplete: "Run complete",
      clogged: "Clogged",
      bestCombo: "Best combo",
      heartsLeft: "Hearts left",
      newBest: "New personal best!",
      finalWeapon: "Final blaster",
      victoryKicker: "Backward Flush!",
      defeatKicker: "The toilets slipped through",
    },
    controls: {
      mobileTip: "Drag anywhere down here to glide",
      skipTutorial: "Skip tutorial",
      activateTriple: "Activate Triple Scoop",
      scoop: "Scoop!",
      bonusGuide: "Bonus controls",
      pause: "Pause game",
      openSettings: "Open settings",
    },
    sidePanel: {
      milestone:
        "10 clogs unlocks Bubble Blaster. 25 unlocks the Golden Plunger Cannon!",
      privacy: "No accounts. No ads. Just silly.",
    },
    settings: {
      kicker: "Make it comfy",
      close: "Close settings",
      soundAndFeel: "Sound & feel",
      music: "Music",
      effects: "Sound effects",
      haptics: "Haptics",
      muteAll: "Mute everything",
      reducedMotion: "Reduced motion",
      controls: "Controls",
      dragSensitivity: "Drag sensitivity",
      tiltSensitivity: "Tilt sensitivity",
      optionalTilt: "Optional tilt",
      enableTilt: "Enable tilt",
      disableTilt: "Disable tilt",
      tiltEnabled: "Tilt enabled. Touch still works.",
      tiltDisabled: "Tilt disabled. Touch remains available.",
      tiltCalibrated: "Tilt enabled and calibrated. Touch still works.",
      tiltUnavailable: "Tilt is unavailable here. Touch works fully.",
      tiltDenied: "Tilt permission was not granted. Touch works fully.",
      visualTutorial: "Visual tutorial",
      tutorialFirst: "Plays automatically on the first run.",
      tutorialCompleted: "Completed. Replay whenever you like.",
      tutorialNext: "Plays on the next run.",
      tutorialReady: "Ready for the next run.",
      replayNext: "Replay next run",
    },
    pwa: {
      updateReady: "A fresh version is ready for the launch bay.",
      offlineReady: "Ready to clog offline!",
    },
    game: {
      dangerLine: "FLUSH ZONE",
    },
    aria: {
      game: "game",
      gameInformation: "Game information",
      gameArea: "Game area",
      actionPlayfield: "action playfield",
      currentRunDetails: "Current run details",
      life: "life",
      lives: "lives",
    },
    error: {
      log: "The game could not continue",
      kicker: "Friendly emergency flush",
      title: "The jetpack needs a tiny reset.",
      explanation:
        "Your best score and comfort settings are still stored on this device.",
      retry: "Try again",
    },
  },
  messages: [
    "You're un-bowl-ievable!",
    "The throne fears you!",
    "Certified Clog Champion!",
    "Ten toilets. Absolute butt legend!",
  ],
} as const;
